var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{staticClass:"text-center"},[_c('v-card-text',[_c('lock-icon',{staticClass:"primary--text",attrs:{"height":"150"}}),_c('v-skeleton-loader',{attrs:{"type":"image","height":"40"}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }